import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, delay, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment'
import { AuthModel, User } from '@share';
import { Menu } from '@delon/theme';
import * as CryptoJS from 'crypto-js'
const apiurl = environment.apiUrl;
const CRYPTO_KEY = environment.cryptoKey
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  
  private tokenKey = 'auth_token'; // LocalStorage key for token
  private userKey = 'user';
  private notiKey='noti';
  private menuKey='menu';
  private permissionKey='permissions';
  
  private authState = new BehaviorSubject<boolean>(this.hasToken());
  private userState= new BehaviorSubject<User|null>(this.getUser());
  private menuState=new BehaviorSubject<Menu[]>(this.getMenu());
  authState$ = this.authState.asObservable(); // Observable to track auth state
  userState$=this.userState.asObservable();
  public menuState$=this.menuState.asObservable();

  constructor() {}

  // Check if token exists
  private hasToken(): boolean {
    return !!this.decryptedData(localStorage.getItem(this.tokenKey));
  }

  private getUser(): User | null {
    let user:User| null = null;
     const json=this.decryptedData(localStorage.getItem(this.userKey));
     if(json){
      user=JSON.parse(json);
     }
     return user;
  }

  private getMenu(): Menu[]{
    let menu:Menu[]= [];
     const json=this.decryptedData(localStorage.getItem(this.menuKey));
     if(json){
      menu=JSON.parse(json);
     }
     return menu;
  }

  public getNotiCount(): number {
    const unreadNotiCount = localStorage.getItem(this.notiKey);
    return unreadNotiCount ? parseInt(unreadNotiCount, 10) : 0;
  }

  // Login function
  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post<AuthModel>(`${apiurl}/admin/login`, credentials).pipe(
      tap((response) => {
        localStorage.setItem(this.tokenKey, this.encryptedData(response.token));
        localStorage.setItem(this.userKey, this.encryptedData(JSON.stringify(response.user)));
        localStorage.setItem(this.menuKey, this.encryptedData(JSON.stringify(response.menu)));
        this.menuState.next(response.menu);
        localStorage.setItem(this.notiKey, `${response.unread_noti_count}`);
        localStorage.setItem(this.permissionKey, this.encryptedData(`${JSON.stringify(response.permission)}`));
        this.authState.next(true); // Update authentication state
      })
    );
  }

  // setNotiCount(data:any){
  //   localStorage.setItem(this.notiKey, `${data}`);
  // }

  // Logout function
  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    localStorage.removeItem(this.notiKey);
    localStorage.removeItem(this.menuKey);
    localStorage.removeItem(this.permissionKey);
    this.authState.next(false);
  }

  // Get the authentication token
  getToken(): string | null {
    return this.decryptedData(localStorage.getItem(this.tokenKey));
  }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    // return this.authState.getValue();
    return !!this.decryptedData(localStorage.getItem(this.tokenKey));
  }
  getLandingRoute(): string | null {
    return this.findLandingRoute(this.menuState.getValue());
  }

  private findLandingRoute(items: Menu[] | undefined): string | null {
    if (!items) {
      return null;
    }
    for (const item of items) {
      if (item.link) {
        return item.link;
      }
      const childLink = this.findLandingRoute(item.children);
      if (childLink) {
        return childLink;
      }
    }
    return null;
  }

  hasPermission(requiredPermissions: string[]): boolean {
    const obj=this.decryptedData(localStorage.getItem(this.permissionKey));
    if(obj)
    {
      const per=(JSON.parse(obj) as string[]);
      return requiredPermissions.every(permission => (JSON.parse(obj) as string[]).includes(permission));
    }
    return false;
    
  }

  private encryptedData(data:any):any{
    return CryptoJS.AES.encrypt(data, CRYPTO_KEY).toString();
  }

  private decryptedData(data:string):any{
    try {
    let result=CryptoJS.AES.decrypt(data, CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
    if(result){
      return result;
    }
  }catch(error){
    return '';
  }
  return '';
  }
}
